'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.offlineStatus = undefined;
var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
var _browser = require('is-online/browser');
var _browser2 = _interopRequireDefault(_browser);
var _actions = require('./actions');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var intervalId = null;
var defaultConfig = {
  intervalLength: 1000 * 30,
  connectionFn: _browser2.default,
  ONLINE_ACTION_NAME: _actions.ONLINE,
  OFFLINE_ACTION_NAME: _actions.OFFLINE
};
var offlineStatus = exports.offlineStatus = function offlineStatus(customConfig) {
  return function (_ref) {
    var getState = _ref.getState,
      dispatch = _ref.dispatch;
    return function (next) {
      return function (action) {
        var result = next(action);
        var config = _extends({}, defaultConfig, customConfig);
        var intervalLength = config.intervalLength,
          connectionFn = config.connectionFn,
          ONLINE_ACTION_NAME = config.ONLINE_ACTION_NAME,
          OFFLINE_ACTION_NAME = config.OFFLINE_ACTION_NAME;
        if (action.type === OFFLINE_ACTION_NAME && !intervalId) {
          intervalId = setInterval(function () {
            connectionFn().then(function (online) {
              return online && dispatch({
                type: ONLINE_ACTION_NAME
              });
            });
          }, intervalLength);
          return result;
        }
        if (action.type === ONLINE_ACTION_NAME && intervalId) {
          clearInterval(intervalId);
          intervalId = null;
        }
        return result;
      };
    };
  };
};